import React, { forwardRef } from 'react';
import noop from 'lodash/noop';

import { cn } from '@lyearn/style';
import { Box, StarRating } from '@lyearn/ui';
import { CellProps } from '@/modules/corporate/modules/database/types';
import { TableViewActionTypes } from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';
import { DatabaseRatingTypeEnum } from '@/types/schema';

import RatingItem from './components/RatingItem';
import { getRatingMaxValue } from './consts';
import { ratingOverrides } from './styles';

const Rating = forwardRef<HTMLDivElement, CellProps>((props, ref) => {
  const {
    columnIndex,
    rowIndex,
    onAction,
    cellData,
    column,
    rowData,
    viewOnly,
    toggleIsEditing,
    className,
  } = props;
  const ratingType = column.field.metadataField.ratingType as DatabaseRatingTypeEnum;

  const onChange = (_: React.ChangeEvent<{}>, newValue: number | null) => {
    if (!newValue) {
      return;
    }
    onAction({
      type: TableViewActionTypes.UpdateCellValue,
      payload: {
        fieldId: column.id,
        documentId: rowData._id,
        data: { value: newValue.toString() },
      },
    });
  };

  const renderRating = (rating: DatabaseRatingTypeEnum) => {
    if (rating === DatabaseRatingTypeEnum.Number) {
      return <RatingItem value={cellData?.value} />;
    }

    return (
      <StarRating
        classes={ratingOverrides}
        max={getRatingMaxValue(column.field.metadataField.validation?.maxValue)}
        name={`${rowIndex}${columnIndex}`}
        size={16}
        value={parseInt(cellData?.value || '0', 10)}
        onChange={viewOnly ? noop : onChange}
      />
    );
  };

  return (
    <Box
      ref={ref}
      className={cn('group flex h-full w-full cursor-pointer items-start px-12 py-8', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={ratingType === DatabaseRatingTypeEnum.Number ? toggleIsEditing : noop}>
      {renderRating(ratingType)}
    </Box>
  );
});

export default Rating;
